import React from 'react'
import '../global.scss'
import { useNavigate } from 'react-router-dom'
import GlobalFooter from '../GlobalFooter';
function PaymentEurInformation() {
    const record = JSON.parse(localStorage.getItem("auth"))

    const navigate = useNavigate();
    const handleClose = ()=>{
        navigate('/pages/payment-credential')
    }

    const handleSubmit = ()=>{
        navigate('/pages/payment-account')
        
    }
  return (
    <div className='global_layout'>
       
       {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
            } */}

    <div className='global_container'>
        <div className='top_bar'>
            <img src='/images/global/arrow-left.svg' alt='' onClick={handleClose}/>
            <img src='/images/global/close.svg' alt='' onClick={handleClose}/>
        </div>

        <div className='global_content'>
            <div className='glob_avater_stick'>
                <img className='img_round' src='/images/global/flickRound.svg' alt='' />
                <img className='img_round rel' src='/images/global/externalLogo.svg' alt='' />
            </div>
            <p className='glob_title'>Lemon Inc</p>
            <p className='glob_desc'>Lemon Inc uses Flick to securely initiate fast payment from bank account</p>
            
            <div className='amount_pattern' style={{marginTop:"20px"}}>
                <p className='glob_name' style={{marginTop:"10px"}}>Deduction Amount</p>
                <p className='glob_amount_value'>£100.00</p>
            </div>
            {/* Phone Number */}
        
            <button  
                className= 'globalBtn'
                style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px"}}
                onClick={handleSubmit}
            >
                
                <p>Continue</p>
                
                <img src='/images/global/activeArrow.svg' alt='' />
                      
            </button>

        </div>
    </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default PaymentEurInformation